import i18n from 'app/i18n';
import api from '../api';

export const EVENTS_UNREAD_REQUEST = 'EVENTS_UNREAD_REQUEST';
export const EVENTS_UNREAD_SUCCESS = 'EVENTS_UNREAD_SUCCESS';
export const EVENTS_UNREAD_FAILURE = 'EVENTS_UNREAD_FAILURE';

const unreadEventsRequest = () => ({
  type: EVENTS_UNREAD_REQUEST,
});

const unreadEventsSuccess = data => ({
  type: EVENTS_UNREAD_SUCCESS,
  payload: data,
});

const unreadEventsFailure = errString => ({
  type: EVENTS_UNREAD_FAILURE,
  payload: { err: errString },
});

/**
* Запрос событий
*/
export const fetchUnreadEvents = () =>
  async (dispatch) => {
    dispatch(unreadEventsRequest());
    try {
      const res = await api('cabinet/events/unread', 'get');
      dispatch(unreadEventsSuccess(res.data));
    } catch (error) {
      dispatch(unreadEventsFailure(i18n.t('app:request_events_unread_failed')));
    }
  };
